import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/auth/AuthContext";

export const GuestRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;
  if (user) return <Navigate to="/" replace />;

  return <>{children}</>;
};
